// extracted by mini-css-extract-plugin
export default {"columns":"columns_columns__O+gS1","debug":"columns_debug__Ae-5D"};